// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__KA9Db","title":"AfterImages45_title__1g9AZ","images":"AfterImages45_images__XV2_s"};